import angular from 'angular';

import OrderStatusSelectorComponent from './order-status-selector-component';

export default angular.module('order-status-selector', []).component('orderStatusSelector', new OrderStatusSelectorComponent());



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/components/order-status-selector/order-status-selector-module.js